// import React, { useMemo } from "react";
// import { Box, Grid, Typography } from "@mui/material";
// import AnalyticsCard, { TrendItem } from "components/analytics/BankingAnalytics/Components/AnalyticsCard";

// import {
//   AccessTime as AccessTimeIcon,
//   CalendarMonth as CalendarMonthIcon,
//   Description as DescriptionIcon,
//   HealthAndSafety as HealthAndSafetyIcon,
//   Leaderboard as LeaderboardIcon,
//   Timeline as TimelineIcon,
//   VerifiedUser as VerifiedUserIcon,
//   Cancel as CancelIcon, 
//   Today as TodayIcon,
        

// } from "@mui/icons-material";


// const PRODUCT_STATUS_CONFIG = {
//   cattle: [
//     "Lead Generated",
//     "Proposal Form Submitted",
//     "Policy Issued",
//     "Policy Rejected",
//   ],
//   crop: [
//     "Lead Generated",    
//   ],
//   motor: [
//     "Lead Generated",
//     "Closed",
   
//   ],
//   health: [
//     "Lead Generated",
//     "Assigned",
   
//   ],
//   cattle_claims: [
//     "Lead Generated",
//     "Claim Accepted",
//     "Claim Approved",
//     "Claim Declined",
//     "Claim Rejected",
//     "Claim Settled",
//   ],
// };


// const STATUS_META = {
//   "Lead Generated": {
//     icon: DescriptionIcon,
//     color: "#0ea5e9",
//   },
//   "Proposal Form Submitted": {
//     icon: TimelineIcon,
//     color: "#6366f1",
//   },
//   "Policy Issued": {
//     icon: VerifiedUserIcon,
//     color: "#22c55e",
//   },
//   "Policy Rejected": {
//     icon: LeaderboardIcon,
//     color: "#ef4444",
//   },
//   "Claim Accepted": {
//     icon: HealthAndSafetyIcon,
//     color: "#16a34a",
//   },
//   "Claim Approved": {
//     icon: VerifiedUserIcon,
//     color: "#22c55e",
//   },
//   "Claim Declined": {
//     icon: AccessTimeIcon,
//     color: "#f97316",
//   },
//   "Claim Rejected": {
//     icon: CancelIcon,
//     color: "#dc2626",
//   },
//   "Claim Settled": {
//     icon: CalendarMonthIcon,
//     color: "#14b8a6",
//   },
// };


// const normalizeStatusData = (data = []) =>
//   data.reduce((acc, item) => {
//     acc[item.current_status] = item.total_count;
//     return acc;
//   }, {});


// export const ProductStatusCards = ({ productKey,insurance, statusData = [],mainStateName }) => {
//     console.log("statusData",statusData)
//   const insuranceSummary = insurance?.summary;

//   const allowedStatuses = PRODUCT_STATUS_CONFIG[productKey] || [];

//   const statusMap = useMemo(
//     () => normalizeStatusData(statusData),
//     [statusData]
//   );

//   return (
//     <>
//     <Grid container spacing={2} className="mb-4">
//       {allowedStatuses.map((status) => {
//         const meta = STATUS_META[status] || {};

//         return (
//           <Grid item xs={12} sm={4} md={3} key={status}>
//             <AnalyticsCard
//               title={status}
//               count={statusMap[status] ?? 0}
//               icon={meta.icon}
//               color={meta.color || "#64748b"}
//             />
//           </Grid>
//         );
//       })}
//        {productKey!=="cattle"&&<Grid item xs={12} sm={6} md={6}>
//                 <AnalyticsCard
//                   title="Leads Summary"
//                   icon={TimelineIcon}
//                   color="#18A2DE"
//                 >
//                   <div
//                     className="d-flex justify-content-between"
//                     style={{ marginTop: "-4.5px" }}
//                   >
//                     <div className="d-flex flex-column gap-2">
//                       <TrendItem
//                         label="Today"
//                         value={insuranceSummary?.total_leads_generated_today}
//                         icon={TodayIcon}
//                         color="#0ea5e9"
//                       />
//                       <TrendItem
//                         label="Last 7 Days"
//                         value={insuranceSummary?.total_leads_generated_last_7_days}
//                         icon={AccessTimeIcon}
//                         color="#6366f1"
//                       />
//                     </div>
//                     <div className="d-flex flex-column gap-2">
//                       <TrendItem
//                         label="Last 1 Month"
//                         value={insuranceSummary?.total_leads_generated_last_1_month}
//                         icon={CalendarMonthIcon}
//                         color="#f59e0b"
//                       />
      
//                       <TrendItem
//                         label="Last 1 Year"
//                         value={insuranceSummary?.total_leads_generated_last_1_year}
//                         icon={TimelineIcon}
//                         color="#22c55e"
//                       />
//                     </div>
//                   </div>
//                 </AnalyticsCard>
//               </Grid>}
//     </Grid>
    
    
//     </>
//   );
// };


import React, { useMemo } from "react";
import { Grid } from "@mui/material";
import AnalyticsCard, { TrendItem } from "components/analytics/BankingAnalytics/Components/AnalyticsCard";

import {
  Description as DescriptionIcon,
  Timeline as TimelineIcon,
  VerifiedUser as VerifiedUserIcon,
  Cancel as CancelIcon,
  Leaderboard as LeaderboardIcon,
  AccessTime as AccessTimeIcon,
  Today as TodayIcon,
 CalendarMonth as CalendarMonthIcon,

} from "@mui/icons-material";


const normalizeStatusData = (data = []) =>
  data.reduce((acc, item) => {
    acc[item.current_status] = item.total_count || 0;
    return acc;
  }, {});

const sumByStatuses = (map, statuses) =>
  statuses.reduce((sum, s) => sum + (map[s] || 0), 0);

/* ------------------ CONFIG ------------------ */

const CARD_CONFIG = {
  cattle: [
    {
      title: "Total Leads",
      statuses: "ALL",
      icon: LeaderboardIcon,
      color: "#0ea5e9",
    },
    {
      title: "Lead Generated",
      statuses: [
        "Lead Generated",
      ],
      exclude: [
        "Proposal Form Submitted",
        "Payment Submitted",
        "Policy Issued",
        "Policy Rejected",
      ],
      icon: DescriptionIcon,
      color: "#6366f1",
    },
    {
      title: "Proposal Submitted",
      statuses: ["Proposal Form Submitted", "Payment Submitted"],
      icon: TimelineIcon,
      color: "#f59e0b",
    },
    {
      title: "Policy Issued",
      statuses: ["Policy Issued"],
      icon: VerifiedUserIcon,
      color: "#22c55e",
    },
    {
      title: "Policy Rejected",
      statuses: ["Policy Rejected"],
      icon: CancelIcon,
      color: "#ef4444",
    },
  ],

  health: [
    {
      title: "Total Leads",
      statuses: "ALL",
      icon: LeaderboardIcon,
      color: "#0ea5e9",
    },
    {
      title: "Lead Generated",
      statuses: ["Lead Generated", "Assigned"],
      icon: DescriptionIcon,
      color: "#6366f1",
    },
  ],

  motor: [
    {
      title: "Total Leads",
      statuses: "ALL",
      icon: LeaderboardIcon,
      color: "#0ea5e9",
    },
    {
      title: "Lead Generated",
      statuses: ["Lead Generated", "Closed"],
      icon: DescriptionIcon,
      color: "#6366f1",
    },
  ],

  crop: [
    {
      title: "Total Leads",
      statuses: "ALL",
      icon: LeaderboardIcon,
      color: "#0ea5e9",
    },
    {
      title: "Lead Generated",
      statuses: ["Lead Generated"],
      icon: DescriptionIcon,
      color: "#6366f1",
    },
  ],

  cattle_claims: [
    {
      title: "Total Leads",
      statuses: "ALL",
      icon: LeaderboardIcon,
      color: "#0ea5e9",
    },
     {
      title: "Lead Generated",
      statuses: ["Lead Generated"],
      icon: DescriptionIcon,
      color: "#22c55e",
    },
    {
      title: "Claim Accepted",
      statuses: ["Claim Accepted"],
      icon: TimelineIcon,
      color: "#22c55e",
    },
     {
      title: "Claim Declined",
      statuses: ["Claim Declined"],
      icon: CancelIcon,
      color: "#dc2626",
    },
   
     {
      title: "Claim Approved",
      statuses: ["Claim Approved"],
      icon: VerifiedUserIcon,
      color: "#16a34a",
    },
     {
      title: "Claim Rejected",
      statuses: ["Claim Rejected"],
      icon: CancelIcon,
      color: "#dc2626",
    },
    {
      title: "Claim Settled",
      statuses: ["Claim Settled","Initiate Payment"],
      icon: TimelineIcon,
      color: "#14b8a6",
    },
  ],
};

/* ------------------ COMPONENT ------------------ */

export const ProductStatusCards = ({ productKey,insurance, statusData = [] }) => {
  const statusMap = useMemo(
    () => normalizeStatusData(statusData),
    [statusData]
  );

  const cards = CARD_CONFIG[productKey] || [];
 const insuranceSummary = insurance?.summary;

  const totalLeads = Object.values(statusMap).reduce(
    (sum, v) => sum + v,
    0
  );

  return (
    <>
    <Grid container spacing={2} className="mb-4">
      {cards.map((card) => {
        let count = 0;

        if (card.statuses === "ALL") {
          count = totalLeads;
        } else if (card.exclude) {
          const included = Object.keys(statusMap).filter(
            (s) => !card.exclude.includes(s)
          );
          count = sumByStatuses(statusMap, included);
        } else {
          count = sumByStatuses(statusMap, card.statuses);
        }

        return (
          <Grid item xs={12} sm={6} md={2.4} key={card.title}>
            <AnalyticsCard
              title={card.title}
              count={count}
              icon={card.icon}
              color={card.color}
            />
          </Grid>
        );
      })}
       {productKey!=="cattle"&&<Grid item xs={12} sm={6} md={6}>
                <AnalyticsCard
                  title="Leads Summary"
                  icon={TimelineIcon}
                  color="#18A2DE"
                >
                  <div
                    className="d-flex justify-content-between"
                    style={{ marginTop: "-4.5px" }}
                  >
                    <div className="d-flex flex-column gap-2">
                      <TrendItem
                        label="Today"
                        value={insuranceSummary?.total_leads_generated_today}
                        icon={TodayIcon}
                        color="#0ea5e9"
                      />
                      <TrendItem
                        label="Last 7 Days"
                        value={insuranceSummary?.total_leads_generated_last_7_days}
                        icon={AccessTimeIcon}
                        color="#6366f1"
                      />
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <TrendItem
                        label="Last 1 Month"
                        value={insuranceSummary?.total_leads_generated_last_1_month}
                        icon={CalendarMonthIcon}
                        color="#f59e0b"
                      />
      
                      <TrendItem
                        label="Last 1 Year"
                        value={insuranceSummary?.total_leads_generated_last_1_year}
                        icon={TimelineIcon}
                        color="#22c55e"
                      />
                    </div>
                  </div>
                </AnalyticsCard>
              </Grid>}
    </Grid>
        
    </>
  );
};
